"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Modal = /*#__PURE__*/function () {
  function Modal(modal, togglers) {
    _classCallCheck(this, Modal);
    this.modal = modal;
    this.container = this.modal.children[0];
    this.togglers = togglers;
    this.closers = _toConsumableArray(this.modal.getElementsByClassName('js-close'));
    this.modalDelay = this.modal ? parseFloat(getComputedStyle(this.modal).transitionDuration.replace('s', '')) * 1000 : 1000;
    this.containerDelay = this.container ? parseFloat(getComputedStyle(this.container).transitionDuration.replace('s', '')) * 1000 : 0;
    this.listen();
  }
  return _createClass(Modal, [{
    key: "listen",
    value: function listen() {
      var _this = this;
      this.togglers.forEach(function (toggler) {
        toggler.addEventListener('click', function () {
          _this.open();
        });
      });
      this.closers.forEach(function (closer) {
        closer.addEventListener('click', function () {
          _this.close();
        });
      });
      this.modal.addEventListener('click', function (event) {
        _this.close();
      });
      this.container.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }
  }, {
    key: "open",
    value: function open() {
      var _this2 = this;
      this.modal.style.display = '-webkit-box';
      this.modal.style.display = '-moz-box';
      this.modal.style.display = '-ms-flexbox';
      this.modal.style.display = '-webkit-flex';
      this.modal.style.display = 'flex';
      document.body.classList.add('has-body-fixed');
      setTimeout(function () {
        _this2.modal.classList.add('is-open');
      }, 10);
    }
  }, {
    key: "close",
    value: function close() {
      var _this3 = this;
      this.modal.classList.remove('is-open');
      document.body.classList.remove('has-body-fixed');
      setTimeout(function () {
        _this3.modal.style.display = 'none';
      }, this.modalDelay + this.containerDelay);
      if (this.modal.id == 'welcome-modal') {
        Cookies.set('igd', 'set', {
          expires: 365
        });
      }
    }
  }]);
}();
document.addEventListener('DOMContentLoaded', function () {
  var modals = _toConsumableArray(document.getElementsByClassName('js-modal'));
  var togglers = _toConsumableArray(document.getElementsByClassName('js-open-modal'));
  if (modals.length) {
    modals.forEach(function (modal, index) {
      if (index == 0 && !Cookies.get('igd')) {
        setTimeout(function () {
          var m = new Modal(modal, togglers.filter(function (toggler) {
            return toggler.dataset.target == modal.id;
          }));
          m.open();
        }, 1000);
      }
    });
  }
});